import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function StaticCard(props:{cardType: "Contact" | "WhereWeAre" | "Sponsored"}) {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation=()=>{
      switch(props.cardType){
        case "Contact":
          navigate(`${location.pathname}/Contact`);
          break;  
        case "WhereWeAre":
          navigate(`${location.pathname}/WhereWeAre`);
          break;
        case "Sponsored": 
          navigate(`${location.pathname}/Sponsored`);
          break;
      } 
    }

    const handleSrc =()=>{
      switch(props.cardType){
        case "Contact":
          return "/images/contatti.jpg"
        case "WhereWeAre":
          return "/images/dove-siamo.jpg"
        case "Sponsored":
          return "/images/sponsored.jpg"
      }
    }
    
    const handleTitle =()=>{
      switch(props.cardType){
        case "Contact": 
          return t("text.contact")
        case "WhereWeAre":
          return t("text.whereWeAre") 
        case "Sponsored":
          return t("text.sponsored")
      }
    }

    return (
        <div className="col">
          <div
            role="button"
            className="icon-style"
            onClick={handleNavigation}
          >
            <div className="card-info">
                <img
                  src={handleSrc()}
                  alt="immagine"
                  style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",  
                        objectPosition: "center",
                        display: "block"
                    }}
                />
              </div>
              <span className="title-card-info mt-2 text-center fw-semibold text-white">
                {handleTitle()}
              </span>
            </div>
          </div>
    )
}
